import * as Sentry from '@sentry/react';

type EventName =
  | 'coverage'
  | 'basicInfo'
  | 'destinations'
  | 'dependants'
  | 'review'
  | 'purchased';

export async function trackHubSpotEvent(eventName: EventName, email: string) {
  const hubspotUrl = process.env.REACT_APP_HUBSPOT_EVENT_API_URL;

  const payload = {
    eventName,
    email
  };

  const response = await fetch(`${hubspotUrl}`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload)
  });

  if (!response.ok) {
    const errorText = await response.text();

    const error = new Error(
      `Failed to track event in HubSpot custom event ${eventName} with error: ${errorText}`
    );
    Sentry.captureException(error);
  }
}
